import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Api} from '../utils';
import {Observable} from 'rxjs/Observable';
import {RequestsHandler} from './requests.service';

@Injectable()

export class AddressService {

  public validCountryCodes = ['SE', 'DK', 'NO', 'FI'];

  constructor(
    private http: HttpClient,
    private api: Api,
    private handler: RequestsHandler
  ) {
  }

  /**
   * Autocomplete addresses
   * @param countryCode
   * @param query
   */
  autocomplete(countryCode: string, query: string) {
    let searchParams = new HttpParams();
    searchParams = searchParams.append('countryCode', countryCode);
    searchParams = searchParams.append('query', query);

    return this.http.get(this.api.getUrl('account/address/autocomplete', 'v2'), {
      headers: this.handler.headers(),
      params: searchParams
    })
      .catch((err: any) => {
        this.handler.handleError(err);
        return Observable.throw(new Error(err));
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/address.service.ts